import { render, staticRenderFns } from "./FinancesTaxTypes.vue?vue&type=template&id=3fb35e44&"
import script from "./FinancesTaxTypes.vue?vue&type=script&lang=js&"
export * from "./FinancesTaxTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports